import SPECIESDATA from "./data/speciesImpact.json";
import BLOCKGROUP_INDEX from "./data/blockgroup-index.json";
import mapboxgl from "mapbox-gl";
import { BGID, Parcel } from "./types";

export function withCommas(value: number, precision?: number) {
  if (value) {
    return value
      .toFixed(precision)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "";
  }
}

export function parcelAddress(parcel: Parcel) {
  return [parcel.ADDR, parcel.CITY, parcel.STATE, parcel.ZIP]
    .filter(Boolean)
    .join(", ");
}

export const treeTypesByAbbr = new Map(
  SPECIESDATA.map((row) => [row.Abbr, row])
);

export function blockgroupBounds(input: BGID | BGID[]) {
  let result;
  const ids = Array.isArray(input) ? input : [input];
  for (let id of ids) {
    const bbox = BLOCKGROUP_INDEX[id];
    const newBounds = mapboxgl.LngLatBounds.convert([
      [bbox[0], bbox[1]],
      [bbox[2], bbox[3]],
    ]);
    result = result ? result.extend(newBounds) : newBounds;
  }
  return result;
}

const METER_TO_ACRE = 4046.86;
export const acre = (val: number) => val / METER_TO_ACRE;

const METER_TO_SQFT = 10.764;
export const sqft = (val: number) => val * METER_TO_SQFT;
